import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Input, Button } from "antd";
import Iconadd from "../../Images/Iconadd.png";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import { list } from "../../api/Apis";
import { formatPhoneNumber } from "../commonFunctions";
import ResizableAntdTable from "resizable-antd-table";
import { CSVLink } from "react-csv";
import moment from "moment";

const Search = Input.Search;
class Drivers extends Component {
  state = {
    loading: false,
    dataLoading: false,
    driversList: [],
    totalDriverList: [],
    totalDriverListCount: 0,
    csvData: [],
  };

  componentDidMount() {
    this.setState({
      dataLoading: true,
    });
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    if (orgDetails.approvalStatus === "D") {
      this.props.history.push("/carrier_app/review");
    } else if (
      !orgDetails["carrierFiles"] ||
      !("documents" in orgDetails["carrierFiles"])
    ) {
      this.props.history.push("/carrier_app/documentation");
    } else if (!orgDetails["isActive"]) {
      this.props.history.push("/carrier_app/review");
    }
    this.getDrivers();
  }

  getDrivers = async () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    // let orgId = localStorage.getItem("orgId");
    let query = {
      userProfile: "D",
      orgId: orgDetails["id"],
    };
    list(AppConfigs["entityNames"]["users"], query).then((result) => {
      if (result.success) {
        this.setState({
          driversList: result.data,
          totalDriverList: result.data,
          totalDriverListCount: result.data?.length,
          dataLoading: false,
          csvData: this.prepareCsvData(result.data),
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
  };

  searchData = (event) => {
    let searcingValue = event.target.value;
    let totalDriverList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      // totalDriverList = this.state.totalDriverList.filter((driver) => driver.address.toLowerCase().indexOf(searcingValue) > -1 || driver.city.toLowerCase().indexOf(searcingValue) > -1 || driver.stateCode.toLowerCase().indexOf(searcingValue) > -1 || driver.firstName.toLowerCase().indexOf(searcingValue) > -1 || driver.lastName.toLowerCase().indexOf(searcingValue) > -1 || driver.zipcode.toLowerCase().indexOf(searcingValue) > -1)
      totalDriverList = this.state.totalDriverList.filter(
        (driver) =>
          driver.firstName.toLowerCase().indexOf(searcingValue) > -1 ||
          driver.lastName.toLowerCase().indexOf(searcingValue) > -1 ||
          driver.email.toLowerCase().indexOf(searcingValue) > -1 ||
          driver.phone.toLowerCase().indexOf(searcingValue) > -1
      );
    } else {
      totalDriverList = this.state.totalDriverList;
    }
    this.setState({
      driversList: totalDriverList,
      csvData: this.prepareCsvData(totalDriverList),
    });
  };

  prepareCsvData = (data) => {
    let csvData = [];
    data.forEach((driver) => {
      csvData.push({
        "Full Name": driver.firstName + " " + driver.lastName,
        Phone: formatPhoneNumber(driver.phone),
        Email: driver.email,
        // following are not in use as of now
        // Location: driver.address,
        // Status: driver.tags[0],
      });
    });
    return csvData;
  }

  generateCsvData = () => {
    return this.prepareCsvData(this.state.driversList);
  }

  render() {
    const columns = [
      {
        title: "Full Name",
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName, record) => (
          <span>{firstName + " " + record.lastName}</span>
        ),
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
        render: (phone, record) => <span>{formatPhoneNumber(phone)}</span>,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      // {
      //   title: 'Location',
      //   dataIndex: 'address',
      //   key: 'address',
      //   render: (address,record) => (
      //     <span>{address}</span>
      //   ),
      // },
      // {
      //   title: 'Status',
      //   key: 'tags',
      //   dataIndex: 'tags',
      //   render: tags => (
      //     <span>
      //       {tags.map(tag => {
      //         let color = tag === 'available' ? 'green' : 'red';

      //         return (
      //           <Tag color={color} key={tag}>
      //             {tag}
      //           </Tag>
      //         );
      //       })}
      //     </span>
      //   ),
      // },
      {
        title: "Action",
        key: "id",
        dataIndex: "id",
        render: (id) => (
          <Link as={Link} to={"/carrier_app/drivers/driverform/" + id}>
            Edit
          </Link>
        ),
      },
    ];
    const paginationConfig = {
      pageSize: 5, // Number of items per page
      total: this.state.totalDriverListCount, // Total number of items
      // Other pagination options if needed
    };
    // const menu = (
    //     <Menu>
    //       {/* <Menu.Item className='blue' >
    //             <Link as={Link} to ="/carrier_app/orders/orderdetails">Load Details</Link>
    //           </Menu.Item>
    //           <Menu.Item className='blue'>
    //             <Link as={Link} to ="/carrier_app/orders/orderdetails">What's the rate?</Link>
    //           </Menu.Item>
    //           <Menu.Item className='blue'>
    //           <Link  as={Link}  onClick={this.showModal}>Open Modal</Link>
    //           </Menu.Item>
    //           <Menu.Item className='blue'>
    //             <Link as={Link} >Download PDF</Link>
    //           </Menu.Item> */}
    //     </Menu>
    //   )
    return (
      <div className="orders">
        <Col lg={24} md={24} sm={24} xs={24}>
          <h1 className="ordertext">Drivers</h1>
        </Col>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24}>
            <Search
              className="products-search"
              size="large"
              placeholder="Search"
              onChange={(event) => {
                this.searchData(event);
              }}
            />
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <Link to="/carrier_app/drivers/driverform" className="adddriver">
              <img
                src={Iconadd}
                style={{ marginRight: "5px" }}
                alt="Add driver"
              />
              Add Driver
            </Link>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "3%" }}>
            <ResizableAntdTable
              style={{ overflowX: "auto" }}
              bordered={true}
              columns={columns}
              dataSource={this.state.driversList}
              rowKey={(record) => record.id}
              loading={this.state.dataLoading}
              pagination={paginationConfig}
            />
            <Button>
                <CSVLink
                data={this.generateCsvData()}
                filename={`Drivers_${moment().format('DD_MM_YY')}.csv`}
              
            >
              Download CSV
              </CSVLink>
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
export default Drivers;
